import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'th-form-field-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './th-form-field-block.component.html',
  styleUrls: ['./th-form-field-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThFormFieldBlockComponent {

}
